import { MDBBtn, MDBInput, MDBSpinner } from "mdb-react-ui-kit";
import "./Auth.scss";
import { useState } from "react";
import { validateForm } from "../../Utils/utils";
import ApiService from "../../Core/Service/ApiService";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAuth } from "../../Store/Reducer/authReducer";
import { useEffect } from "react";
import { useContext } from "react";
import CmsContext from "../../Context/CmsContext";

const Login = () => {
    const cmsContext = useContext(CmsContext);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loggingIn, setLoggingIn] = useState(false);
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [inputErrors, setInputErrors] = useState({});
    const rules = {
        username: {
            required: 'string'
        },
        password: {
            required: 'string'
        }
    }

    useEffect(() => {
        cmsContext.setCurrMainMenu(null);
        cmsContext.setCurrSubMenu(null);
        cmsContext.setSidebarCollapsed(null);
    }, [])

    const handleInputChange = (e) => {
       setFormData({
        ...formData,
        [e.target.name]: e.target.value
       }) 
    }

    const handleLogin = (e) => {
        e.preventDefault();

        const ret = validateForm(formData, rules);
        if(!ret.result) {
            setInputErrors(ret.errors);
        } else {
            setInputErrors({});
            setLoggingIn(true);

            ApiService.post('/login', formData).then((response)=>{
                const {authUser, authToken} = response.data;
                dispatch(setAuth({
                    authUser,
                    authToken
                }));
                navigate('/empty');
            })
            .finally(()=>{
                setLoggingIn(false);
            });
        }
    }

    return <div className="login-container d-flex flex-column justify-content-center align-items-center">
        <div className="w-100 mt-4 login-panel">
            <form>
                <img className="logo-img" src="/img/logo/uws-logo.jpg" />
                <div className="mt-4">
                    <label>Username:</label>
                    <MDBInput name="username" type="text" value={formData.username} onChange={handleInputChange} />
                    {inputErrors?.username && <div className="error">{inputErrors.username}</div>}
                </div>
                <div className="mt-4">
                    <label>Password:</label>
                    <MDBInput name="password" type="password" value={formData.password} onChange={handleInputChange} />
                    {inputErrors?.password && <div className="error">{inputErrors.password}</div>}
                </div>
                <div className="mt-4 d-flex justify-content-end">
                    <MDBBtn type="submit" onClick={handleLogin}>
                        {loggingIn && <MDBSpinner className="me-2" size="sm" />}
                        <span>Log In</span>
                    </MDBBtn>
                </div>
            </form>
        </div>
    </div>
}

export default Login;